/** Revoke blob: URLs created for local file previews. */
export function revokePreviewUrls(urls) {
  const list = Array.isArray(urls) ? urls : Object.values(urls || {});
  list.forEach((url) => {
    if (typeof url === "string" && url.startsWith("blob:")) {
      URL.revokeObjectURL(url);
    }
  });
}
